import React from 'react';

interface OwnProps {
  to: string;
}

type Props = Readonly<OwnProps>;

const AbsoluteRedirect: React.FC<Props> = ({ to }) => {
  React.useEffect(() => {
    window.location.assign(to);
  }, []);

  return null;
};

export default AbsoluteRedirect;
